<script lang="ts" setup>
import { onBeforeUnmount, ref } from '#imports';
import GeneralConfirm from '@core/components/Confirm/GeneralConfirm.vue';
import { usePasteUpload } from '../composables/use-paste-file';
import { useDragFile } from '../composables/use-drag-file';

const props = defineProps({
  onFile: {
    type: Function,
    required: true,
  },
});
const confirmToDo = ref(false);
const file = ref<File>();
const targetRef = ref<HTMLElement>();
usePasteUpload({
  onFiles: (files) => {
    file.value = files[0];
    confirmToDo.value = true;
  },
  useCapture: true,
  pasteTargetRef: () => targetRef.value,
});
useDragFile({
  onFiles: (files) => {
    file.value = files[0];
    confirmToDo.value = true;
  },
  dragAreaRef: () => targetRef.value,
});
onBeforeUnmount(() => {
  confirmToDo.value = false;
});
function handleOk() {
  props.onFile(file.value);
}
function onCancel() {
  confirmToDo.value = false;
  file.value = undefined;
}
</script>
<template>
  <div ref="targetRef">
    <slot></slot>
    <GeneralConfirm
      v-model:open="confirmToDo"
      :auto-close="true"
      :title="'提示'"
      :content="'确定要发送' + file?.name + '吗？'"
      cancel-text="取消"
      ok-text="确定"
      @ok="handleOk"
      @cancel="onCancel"
    />
  </div>
</template>
